import { API_BASE } from './apiBase';

const API_URL = API_BASE;
const PING_INTERVAL = 5 * 60 * 1000; // 5 minutes

let intervalId = null;

export function startKeepAlive() {
  if (intervalId) return;

  const ping = () => {
    fetch(`${API_URL}/api/`, { method: 'GET' }).catch(() => {});
  };

  // Defer first ping until browser is idle (don't block initial render)
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(() => {
      ping();
      intervalId = setInterval(ping, PING_INTERVAL);
    });
  } else {
    setTimeout(() => {
      ping();
      intervalId = setInterval(ping, PING_INTERVAL);
    }, 3000);
  }
}

export function stopKeepAlive() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}
